import { MultipleChoiceQuestion, MultipleSelectionQuestion, Question } from '../../common/questions/question.models';
import { AfterViewInit, ElementRef } from '@angular/core';
import { ChoiceResponse, QuestionResponse, SelectionResponse } from '../../common/questions/response.model';

export abstract class BaseQuestionComponent {
}
